/**
 * Stylesheet des Renderers. Wird 1:1 vom Editor-Surface und von renderToHtml (Druck) benutzt.
 * Alle Längen im Dokument sind mm; `--mm` ist die Anzahl Pixel pro mm und die einzige Stelle,
 * an der Vorschau und Druck sich unterscheiden.
 *
 * DOM-Konvention (Paritätstest vergleicht `.dr-root`):
 *   div.dr-root[style=--mm;width;height]
 *     div.dr-bg
 *     div.dr-layer.dr-layer--image[data-layer-id] > div.dr-image-clip > img.dr-image
 *     div.dr-layer.dr-layer--text[data-layer-id]  > div.dr-text
 *     div.dr-layer.dr-layer--sticker[data-layer-id] > img.dr-sticker
 *     div.dr-layer.dr-layer--shape[data-layer-id] > svg.dr-shape
 */
export const BASE_CSS = `
.dr-root{position:relative;overflow:hidden;box-sizing:border-box;margin:0;padding:0;
  text-rendering:geometricPrecision;-webkit-font-smoothing:antialiased;image-rendering:auto;
  font-kerning:normal;line-height:1;}
.dr-root *{box-sizing:border-box;margin:0;padding:0;}
.dr-bg{position:absolute;inset:0;}
.dr-bg-img{position:absolute;display:block;}
.dr-layer{position:absolute;transform-origin:center center;}
.dr-layer--hidden{display:none;}
.dr-image-clip{position:absolute;inset:0;overflow:hidden;}
.dr-image{position:absolute;display:block;max-width:none;}
.dr-placeholder{position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;
  gap:calc(var(--mm)*2);overflow:hidden;background:rgba(15,23,42,0.05);
  background-image:repeating-linear-gradient(45deg,rgba(15,23,42,0.05) 0 calc(var(--mm)*2),transparent calc(var(--mm)*2) calc(var(--mm)*5));}
.dr-placeholder::before{content:"";flex:none;width:calc(var(--mm)*14);height:calc(var(--mm)*14);max-width:38%;max-height:38%;
  aspect-ratio:1;border-radius:50%;background:#fff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='1.75' stroke-linecap='round' stroke-linejoin='round'%3E%3Crect x='3' y='3' width='18' height='18' rx='2'/%3E%3Ccircle cx='9' cy='9' r='2'/%3E%3Cpath d='m21 15-3.1-3.1a2 2 0 0 0-2.8 0L6 21'/%3E%3C/svg%3E") center/50% no-repeat;
  box-shadow:0 1px 3px rgba(15,23,42,0.18);}
.dr-placeholder::after{content:"Foto hinzufügen";max-width:90%;font:600 clamp(9px,calc(var(--mm)*3.6),16px)/1.2 system-ui,-apple-system,"Segoe UI",sans-serif;
  color:rgba(15,23,42,0.55);text-align:center;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
.dr-root--print .dr-placeholder{background:transparent;background-image:none;}
.dr-root--print .dr-placeholder::before,.dr-root--print .dr-placeholder::after{display:none;}
.dr-text{position:absolute;inset:0;display:flex;flex-direction:column;white-space:pre-wrap;overflow-wrap:anywhere;
  word-break:normal;overflow:hidden;}
.dr-text>span{display:block;width:100%;}
.dr-sticker{position:absolute;inset:0;width:100%;height:100%;display:block;object-fit:contain;}
.dr-shape{position:absolute;inset:0;width:100%;height:100%;display:block;overflow:visible;}
.dr-mask-defs{position:absolute;width:0;height:0;overflow:hidden;}
`
